import React, { Component } from "react";
import PropTypes from "prop-types";

import { Card } from "react/card/Card";
import CardTitle from "react/card/CardTitle";
import { OverviewFooter } from "react/card/OverviewFooter";
import ContentTitle from "react/views/generic/ContentTitle";
import parseHtml from 'react/containers/helper/parseHtml';
import ScrollableText from "react/views/generic/ScrollableText";

import "./bookContents.less";

const ParsedScrollableText = parseHtml(ScrollableText);

class BookExtrasView extends Component {
	render() {
		const {cardName, image, title, text, numberOfLines } = this.props;

		return (
			<Card>
				<CardTitle title={cardName} />
				<div className="book-contents">
					{image}
					<ContentTitle>{title}</ContentTitle>
					<div className="book-contents-text">
						<ParsedScrollableText html={text} line={numberOfLines || 11} />
					</div>
				</div>
				<OverviewFooter />
			</Card>
		);
	}
}

BookExtrasView.propTypes = {
	cardName: PropTypes.string.isRequired,
	image: PropTypes.element,
	title: PropTypes.string,
	text: PropTypes.string
};

export default BookExtrasView;







// WEBPACK FOOTER //
// ./src/react/views/bookExtras/BookExtrasView.jsx